
enum DefaultColor {

  //Main palette.
  Black = '#000000',
  White = '#FFFFFF',
  Background = '#eff3f5',
  BackgroundDark = '#FAF7F7',
  Primary = '#e43236',
  Secondary = '#89c2d0',
  Success = '#36C2A1',
  Warning = '#fdbe1d',
  Error = '#F7422A',
  Info = '#2196f3',
  TextPrimary = '#0a1f3d',
  TextSecondary = '#566a7d',
  TextLight = '#8898a7',
  TextDisabled = '#9AAAB9',
  TextHighlight = '#fcdf95',
  Notification = '#ff0000',

  //Elements.
  Sidebar = '#091f46',
  SidebarTitle = '#dfd6ff',
  SidebarItemText = 'rgba(255,255,255,0.5)',
  SidebarItemTextSelected = '#ffffff',
  SidebarItemHover = '#150f3a',
  SidebarItemSelected = '#1a114b',
  SidebarIcon = 'rgba(255,255,255,1)',
  SidebarIconSelected = '#89c2d0',
  Divider = '#eff1f4',

  Button = '#FAF7F7',

  Spinner = '#566a7d',

  Avatar = '#d4dce4',
  AvatarText = '#454867',
  AvatarColor = '#7a49ef',
  AvatarColorText = '#ffffff',

  //Tags.
  StatusConfirm = '#36C2A1',
  StatusWarning = '#fdbe1d',
  StatusError = '#F7422A',
}

export default DefaultColor